module.exports = __webpack_public_path__ + "frontend/images/07803a9b3269d1800e052937823cd98b.gif";